import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { UiEffects } from "./store/ui/ui.effects";
import { CommonFeEffectsModule } from 'common-lib';
import { PortalUserEffects } from "./store/user/portal-user.effects";
import { PortalLivestockEffects } from "./store/livestock/portal-livestock-effects.service";

/** Module that runs all effects for the app. */
@NgModule({
  imports: [
    CommonFeEffectsModule,
    EffectsModule.forFeature([
      UiEffects,
      PortalLivestockEffects,
      PortalUserEffects
    ])]
})
export class PortalEffectsModule {
}
